import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { LoginPayload, LoginResponse, User, VendorPayload, VendorResponse } from './types';
import { signIn, getCurrentUser, fetchUserAttributes } from "aws-amplify/auth";
import { api_url } from '../../api/config/config';

export const loginUser = createAsyncThunk<
  LoginResponse,
  LoginPayload,
  { rejectValue: string }
>(
  'auth/login',
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const { isSignedIn, nextStep } = await signIn({ username: email, password });

      const { username, userId, signInDetails } = await getCurrentUser();

      const attributes = await fetchUserAttributes();
      // custom:status(有効/無効) が "1" でなければ reject
      if (attributes['custom:status'] !== '1') {
        return rejectWithValue('このアカウントは現在使用できません。');
      }

      const loginData: LoginResponse = {
        success: true,
        data: {
          user: {
            id: userId,
            email: attributes.email || '',
            firstName: attributes['custom:first_name'] || '',
            lastName: attributes['custom:last_name'] || '',
            vendorId: attributes['custom:enebid_vendor_id'] || '',
            vendorDeptId: attributes['custom:enebid_vend_dept_id'] || '',
          },
          token: '',
          tokenExpiry: '',
        },
      };

      return loginData;

    }
    catch (error: any) {
      console.error('ログイン失敗:', error);

      if (error.name) {
        switch (error.name) {
          case 'UserNotFoundException':
            return rejectWithValue('このメールアドレスは登録されていません。');
          case 'NotAuthorizedException':
            return rejectWithValue('メールアドレスまたはパスワードが正しくありません。');
          case 'UserNotConfirmedException':
            return rejectWithValue('アカウントが未確認です。確認メールをご確認ください。');
          case 'PasswordResetRequiredException':
            return rejectWithValue('パスワードのリセットが必要です。');
          case 'TooManyFailedAttemptsException':
            return rejectWithValue('ログイン試行が多すぎます。しばらくしてから再試行してください。');
          default:
            return rejectWithValue('ログインに失敗しました。' + error.message);
        }
      }
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }

      return rejectWithValue('予期せぬエラーが発生しました。' + error.message);
    }
  }
);

export const getVendorUserById = createAsyncThunk<VendorResponse, VendorPayload>(
  'user/getVendorUserById',
  async ({ id }, { rejectWithValue }) => {

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const response = await axios.post(
        `${api_url}/getVendorUserById`,
        { id },
        config
      );

      return response.data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);